import {
  fetchCurrentSubscription,
  FetchCurrentSubscriptionResponse,
} from "@client/clinic";
import { dietitianKeys } from "@hooks/queries/dietitian/dietitianKeys";
import { QueryOptionsTyped } from "../types";
import { useQuery } from "@tanstack/react-query";

export const useFetchCurrentSubscriptionQuery = (
  options?: QueryOptionsTyped<FetchCurrentSubscriptionResponse>,
) => {
  return useQuery({
    queryKey: dietitianKeys.currentSubscription(),
    queryFn: fetchCurrentSubscription,
    ...options,
  });
};
